import React, { useState } from 'react';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { Box, Grid, MenuItem, Stack, TextField } from '@mui/material';

import { useGetRolesQuery } from '@/services';
import { AppBar, Empty, Error, Loader } from '@/components';
import { OrderDirections, ORDER_DIRECTIONS } from '@/utils/order-directions';

import { RolesTable, CreateRole } from './components';

const RolesPage: React.FC = () => {
  const [{ order_direction, page }, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    order_direction: withDefault(StringParam, OrderDirections.DESC),
  });

  const [createModalOpened, setOpenedCreateModal] = useState(false);

  const {
    data: roles,
    isLoading,
    isSuccess,
    isError,
  } = useGetRolesQuery({ params: { order_direction, page, order_by: 'id' } });

  return (
    <>
      <AppBar title="Роли" />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
            <Box sx={{ width: 310 }}>
              <TextField
                select
                value={order_direction}
                label="Сортировать по"
                disabled={isLoading}
                onChange={(event) => setQuery({ order_direction: event.target.value })}
                variant="filled"
                fullWidth
                size="small"
              >
                {ORDER_DIRECTIONS.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Stack>
        </Grid>

        <Grid item lg={4} md={6} xs={12}>
          {isLoading ? (
            <Loader />
          ) : isError ? (
            <Error text="Произошла ошибка с загрузкой ролей! Пожалуйста, попробуйте позже" />
          ) : isSuccess && Boolean(roles?.data?.length) ? (
            <RolesTable list={roles} page={page} onChangePage={(page) => setQuery({ page })} />
          ) : (
            <Empty text="Роли отсутствуют" />
          )}
        </Grid>
      </Grid>

      <CreateRole onClose={() => setOpenedCreateModal(false)} open={createModalOpened} />
    </>
  );
};

export default RolesPage;
